// TODO: These keys are just globally used, not limited to Cookies, should change the file name.

export const USER_UID_COOKIES = 'user_uid'
export const SEGMENT_ANONYMOUS_ID_COOKIES = 'ajs_anonymous_id'
export const DEVICE_COOKIES = 'device'
export const CSR_NAV_TRACK = 'CSR_NAV_TRACK'
export const POMELO_CARES_PAYPAL_WEBVIEW = 'pomelo_cares_paypal_webview'
export const WEB_VIEW_X_PLATFORM = 'webview_x_platform'
export const DISABLE_NAV_PROGRESS = 'disable_nav_progress'
